import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatError } from "@/lib/api";
import { VoiceoverBox, replaceFreeLine } from "@/components/PostScript";

/** قاعدة كل المسارات (كما في الحملات): اختر الصوت ← اسمع التعليق على النص نفسه ← احفظه ← ولّد. ما تسمعه هو ما يُنتج حرفيًا. */
export const StudioVoiceBox = ({ projectId, text, voice, style = "", free = false, onReady, onChangeText, testId = "studio" }) => {
  const [previewed, setPreviewed] = useState(false);
  const [approved, setApproved] = useState(false);
  const [approving, setApproving] = useState(false);
  useEffect(() => { setPreviewed(false); setApproved(false); onReady?.(false); }, [text, voice, style]); // eslint-disable-line
  const request = ({ voice: v, style: s, script }) => api.post("/content/voice-preview", { project_id: projectId, voice: v, style: s, script }, { responseType: "blob", timeout: 180000 });
  const approve = async () => {
    setApproving(true);
    try {
      await api.put("/content/voice-approve", { project_id: projectId, voice, style, script: text });
      setApproved(true); onReady?.(true);
      toast.success("صوت التوليد محفوظ — هذا التسجيل نفسه يُستخدم في الفيديو");
    } catch (e) { toast.error(formatError(e.response?.data?.detail)); }
    finally { setApproving(false); }
  };
  // تعديل جملة من الصندوق الأصفر يعدّل النص الأصلي نفسه (السكربت/الوصف) — ما يُكتب هنا هو ما يُنطق
  const changeLine = onChangeText ? (i, v) => onChangeText(replaceFreeLine(text, i, v)) : undefined;
  return (
    <VoiceoverBox text={text} postId={testId} voice={voice} style={style} free={free} request={request} onChangeLine={changeLine}
      previewed={previewed} onPreviewed={() => setPreviewed(true)} voiceApproved={approved} onApproveVoice={approve} approvingVoice={approving} dirty={false} />
  );
};
